import React, { useEffect, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { responsiveFontSizes, useTheme } from '@mui/material/styles';
import {
    Box, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableFooter,
    TablePagination, TableRow, TableHead, Paper, IconButton, Dialog, DialogActions,
    Avatar, DialogContentText, DialogTitle, Button, Slide, Snackbar,
    Alert,
    CardMedia,
    Card,
    CardHeader,
    Chip,
    DialogContent
} from '@mui/material';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import {
    FirstPage as FirstPageIcon,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    LastPage as LastPageIcon,
    Visibility as VisibilityIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';
import { getMentorData, getMentorStudentData, UpdateStatusStudentData } from "../services"; 
import { useNavigate, useParams } from 'react-router-dom';
import { safeDecryptId } from '../utils/safeDecryptId';

// Slide transition for dialog
const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// Custom pagination actions
function TablePaginationActions({ count, page, rowsPerPage, onPageChange }) {
    const theme = useTheme();

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton onClick={(e) => onPageChange(e, 0)} disabled={page === 0}>
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={(e) => onPageChange(e, page - 1)} disabled={page === 0}>
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton onClick={(e) => onPageChange(e, page + 1)} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton onClick={(e) => onPageChange(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1))} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function MentorStudentList() {
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [open, setOpen] = useState(false);
    const [selectedMentorId, setSelectedMentorId] = useState(null);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
     const navigate = useNavigate();
    const [mentorId, setMentorId] = useState(null);
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const { id: encryptedId } = useParams();

    const fetchData = async () => {
        try {
            const res = await getMentorStudentData(mentorId);
            setRows(res.data);
        } catch (err) {
            console.error('Error fetching mentors:', err);
        }
    };
    const handleSnackbarClose = () => {
        setSnackbar((prev) => ({ ...prev, open: false }));
    };
    useEffect(() => {
        const decryptedId = safeDecryptId(encryptedId, secretKey);
        if (!decryptedId) {
            navigate("/unauthorized");
            return;
        }
        setMentorId(decryptedId);
        // fetchData();
    }, [encryptedId, secretKey]);
        useEffect(() => {
        if (mentorId) {
            fetchData();
        }
        }, [mentorId]);
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleClickOpen = (id) => {
        setSelectedMentorId(id);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedMentorId(null);
    };
    const handleStatusConfirm = async (bool) => {
        // console.log("resp", bool)
        try {
            const reposnse = await UpdateStatusStudentData(selectedMentorId, bool);

            if (reposnse.status === 200) {
                fetchData(); // refresh list
                handleClose();
                setSnackbar({
                    open: true,
                    message: "Meeting status set successful!",
                    severity: "success",
                });
            }

        } catch (err) {
            setSnackbar({
                open: true,
                message: err?.response?.data?.message || "Login failed. Please try again.",
                severity: "error",
            });
        }
    };

    return (
        <>


            <CardContent sx={{ marginTop:{
          xs:"35px"
        }}}>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: "15px" }}>
                    <Card >
                        <CardHeader
                            title="Student List"
                            sx={{
                                backgroundColor: 'grey',
                                color: 'white',
                                textAlign: 'left',
                                paddingY: 1,
                                paddingX: 2
                            }}
                        />
                        {/* <Box sx={{ display: 'flex', alignItems: 'center', padding: 2 }}>
                            {rows[0]?.mentor?.profile ? (
                                <CardMedia
                                    component="img"
                                    image={rows?.mentor?.profile}
                                    alt={rows?.mentor?.name}
                                    style={{ height: 140, objectFit: 'cover', backgroundColor: "white" }}
                                />
                            ) : (
                                <Box display="flex" justifyContent="center" alignItems="center" height={140} bgcolor="#white">
                                    <Avatar
                                        sx={{ width: 80, height: 80, fontSize: 32, color: "#1976d2" }}
                                    >
                                        {rows[0]?.mentor?.name?.[0]?.toUpperCase() || '?'}
                                    </Avatar>
                                </Box>
                            )}
                            <CardContent sx={{ textAlign: 'left' }} >
                                <Typography variant="h6">{rows[0]?.mentor?.name}</Typography>
                                <Typography variant="body2" color="textSecondary">{rows[0]?.mentor?.email}</Typography>
                            </CardContent>
                        </Box> */}
                    </Card>
                    {/* <Typography variant='h4' gutterBottom alignSelf="center">Student List</Typography> */}
                </Box>

                <TableContainer component={Paper}>
                    <Table >
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#f0f0f0' }}>
                                <TableCell>Name</TableCell>
                                <TableCell align="left">Email</TableCell>
                                <TableCell align="left">Price(INR)</TableCell>
                                <TableCell align="left">Date</TableCell>
                                <TableCell align="left">Time</TableCell>
                                <TableCell align="left">Meeting Status</TableCell>
                                <TableCell align="left">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(rowsPerPage > 0
                                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : rows
                            ).map((row) => (
                                <TableRow key={row.id} >
                                    <TableCell>
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <Avatar src={row?.user?.profile || ''}>
                                                {!row.user?.profile && row.user?.name?.[0]?.toUpperCase()}
                                            </Avatar>
                                            <Typography variant="body1">{row.user?.name}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left">{row.user?.email}</TableCell>
                                    <TableCell align="left">{row?.price}</TableCell>
                                    <TableCell align="left">{row?.mentor_time_mapping_tb?.date}</TableCell>
                                    <TableCell align="left">{row?.mentor_time_mapping_tb?.hour?.slot_time}</TableCell>
                                    <TableCell align="left">
                                        {row.isaccepted === null ? (
                                            <Chip label="PENDING" color="warning" />
                                        ) : row.isaccepted === 1 ? (
                                            <Chip label="ACCEPTED" color="success" />
                                        ) : (
                                            <Chip label="REJECTED" color="error" />
                                        )}
                                    </TableCell>

                                    <TableCell align="left">
                                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-start' }}>
                                            <IconButton color="primary" size="small" onClick={() => handleClickOpen(row.id)}>
                                                <MeetingRoomIcon />
                                            </IconButton>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 53 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                    count={rows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>
            </CardContent>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
            <Dialog open={open} TransitionComponent={Transition} keepMounted onClose={handleClose}>
                <DialogTitle>Meeting Status</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you want to accept/reject this meeting?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>

                    <Button onClick={() => handleStatusConfirm(true)} color="success">Accept</Button>
                    <Button onClick={() => handleStatusConfirm(false)} color="error">Reject</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
